// extracted by mini-css-extract-plugin
export default {"googleLoginButton":"GoogleLoginStyle_googleLoginButton__QqnsF"};